import {Component, OnInit, Input, forwardRef, Optional, Self, AfterViewInit} from '@angular/core';
import * as tinycolor from 'tinycolor2';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {ColorPickerControl} from '@iplab/ngx-color-picker';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-ldd-module-color-picker',
  templateUrl: './ldd-module-color-picker.component.html',
  styleUrls: ['./ldd-module-color-picker.component.scss'],
  providers: [
    // {
    //   provide: NG_VALUE_ACCESSOR,
    //   useExisting: forwardRef(() => LddModuleColorPickerComponent),
    //   multi: true
    // }
  ],
})
export class LddModuleColorPickerComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  // public compactControl = new ColorPickerControl();

  @Input()
  presets: string[];

  @Input()
  placeholder: string;

  backdrop = false;

  private _value: string;
  disabled: boolean;
  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
    this.propagateChange(this._value);
  }
  private unregister$ = new Subject();
  private propagateChange = (_) => {};
  private onTouched = () => {};

  registerOnChange(fn: () => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: string): void {
    this._value = obj;
  }

  constructor(@Optional() @Self() public ngControl?: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  set color(col: string) {
    this.ngControl.control.setValue(col);
    this.ngControl.control.markAsDirty();
  }

  get color() {
    return this.ngControl.control.value;
  }

  ngOnInit() {
  }

  setBackdrop(on: boolean) {
    this.backdrop = on;
  }

  getTextColor(col: string) {
    return tinycolor(col).isLight() ? '#000' : '#fff';
  }

  ngAfterViewInit() {
    this.ngControl.valueChanges.subscribe(value => {
      this._value = value;
    });
  }
}
